module.exports = __webpack_public_path__ + "static/media/3.96be1f51.svg";